import produce from 'immer';
import { NewPostActionType, NewPostState, NewPostActions } from 'store/types/newPostTypes';

const initialState: Readonly<NewPostState> = { posts: {} };

const newPostReducer = (state = initialState, action: NewPostActionType) =>
  produce(state, draft => {
    switch (action.type) {
      case NewPostActions.CHANGE_VISIBILITY:
        if (!draft.posts[action.payload.storeKey]) {
          draft.posts[action.payload.storeKey] = {
            content: '',
            targets: [],
            visibility: action.payload.visibility,
          };
        } else {
          draft.posts[action.payload.storeKey]!.visibility = action.payload.visibility;
        }
        break;

      case NewPostActions.CHANGE_PROFILE:
        // 🚨 PROTEÇÃO: Se o Redux ainda não inicializou essa chave, cria ela agora!
        if (!draft.posts[action.payload.storeKey]) {
          draft.posts[action.payload.storeKey] = {
            visibility: 1 as any, // 🚨 Burlamos o TypeScript aqui para ele aceitar o valor inicial
            content: '',
            targets: [],
          };
        }
        draft.posts[action.payload.storeKey]!.profile = action.payload.profile;
        break;

      case NewPostActions.ADD_TARGET:
        if (!draft.posts[action.payload.storeKey]) {
          draft.posts[action.payload.storeKey] = {
            content: '',
            targets: [],
            visibility: 1 as any, // 🚨 Mesma correção aqui
          };
        }
        draft.posts[action.payload.storeKey]!.targets = action.payload.targetsId;
        break;

      case NewPostActions.INIT: {
        draft.posts[action.payload.storeKey] = {
          visibility: action.payload.visibility,
          content: '',
          targets: [],
        };
        break;
      }
    }
  });

export default newPostReducer;
